import { TAchievementType } from '@components/achievement';

export const achievements: {
  title: string;
  description: string;
  type: TAchievementType;
  progress: number;
  goal: number;
}[] = [
  {
    title: 'Real Gladiator [8]',
    description: 'Play a 5000 games on Duelana',
    type: 'lyla',
    progress: 4600,
    goal: 5000,
  },
  {
    title: 'Duel Lover',
    description: 'plays 10 games choosing the Duel side',
    type: 'grey',
    progress: 8,
    goal: 10,
  },
  {
    title: 'Real Gladiator [1]',
    description: 'Play a 5000 games on Duelana',
    type: 'green',
    progress: 2000,
    goal: 5000,
  },
  {
    title: 'Real Gladiator [2]',
    description: 'Play a 10000 games on Duelana',
    type: 'grey',
    progress: 2000,
    goal: 10000,
  },
];
